/**
 * @module app.core
 */

import { bindable } from 'aurelia-framework';
import { ICustomFieldDefinition, ICustomFieldDefinitionContainer } from '../interfaces';

export interface ICustomEditModel {
    definition: ICustomFieldDefinition;
    container: ICustomFieldDefinitionContainer;
    disabled: boolean | null;
};

export class CustomEdit {

    @bindable
    public definition: ICustomFieldDefinition | null = null;

    @bindable
    public container: ICustomFieldDefinitionContainer | null = null;

    @bindable
    public disabled: boolean | null = null;

    constructor() { }

    public getModel(definition: ICustomFieldDefinition | null, container: ICustomFieldDefinitionContainer | null, disabled: boolean | null): ICustomEditModel | null {
        if(definition && container) {
            return { definition, container, disabled };
        }
        return null;
    }

    public getViewModel(definition: ICustomFieldDefinition | null): string | null {
        if(definition && definition.property && definition.property.type) {
            return `./custom-edit-${definition.property.type}`;
        }
        return null;
    }

}
